import React from 'react';
import { Controller, FieldValues, UseControllerProps, UseControllerReturn } from 'react-hook-form';
import { PhoneNumberValue } from '../../../lib/phoneValidation';
import { PhoneInputWithCountryCode } from './PhoneInputWithCountryCode';

interface PhoneFieldControllerProps {
  errorMessage?: string;
  disabled?: boolean;
  rules?: any;
}

export const PhoneFieldController = <T extends FieldValues>({
  control,
  defaultValue,
  errorMessage,
  name,
  disabled,
  rules,
}: UseControllerProps<T> & PhoneFieldControllerProps) => (
  <Controller
    rules={rules}
    name={name}
    control={control}
    defaultValue={defaultValue}
    render={({ field: { onChange, value } }: UseControllerReturn<T>) => (
      <PhoneInputWithCountryCode
        value={value as PhoneNumberValue | undefined}
        onChange={onChange}
        errorMessage={errorMessage}
        disabled={disabled}
      />
    )}
  />
);
